import { render, staticRenderFns } from "./veStuCheckItem.vue?vue&type=template&id=37e5c319&scoped=true"
import script from "./veStuCheckItem.vue?vue&type=script&lang=js"
export * from "./veStuCheckItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5c319",
  null
  
)

export default component.exports